import { useAccountContext } from "./useAccountContext";
import { useState } from "react";
import { useAuthContext } from "./useAuthContext";
import { useSettingsContext } from "./useSettingsContext";
import { generateUniqueID } from "../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";
import axios from "axios";

export const useHRAdminEmplAdvancedSettings = () => {
    const {
        username,
        user,
        clientApi,
        dispatch: authDispatch,
    } = useAuthContext();
    const { account } = useAccountContext();
    const [isLoading, setIsLoading] = useState(false);
    const { isWinAuth } = useSettingsContext();

    const axiosInstance = axios.create({
        baseURL: `${clientApi}`,
        headers: {
            accepts: "application/json",
            "Content-Type": "application/json",
        },
    });

    axiosInstance.interceptors.request.use(
        (request) => {
            const accessToken = user.token;
            if (accessToken) {
                request.headers["Authorization"] = `Bearer ${accessToken}`;
            }
            return request;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        response => response, // Directly return successful responses.
        async error => {
            const originalRequest = error.config;
            if (error?.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
                try {
                    if (!isWinAuth) {
                        // Make a request to your auth server to refresh the token.
                        const response = await axiosInstance.post(`${clientApi}api/auth/refresh`, user);
                        // Store the new access and refresh tokens.
                        authDispatch({ type: 'Refresh', payload: response.data, clientApi: clientApi, username: username });

                        // Update the authorization header with the new access token.
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                    }
                    else {
                        const newToken = await acquireSilentToken();
                        let tmpUser = user;
                        tmpUser.token = newToken;
                        authDispatch({ type: 'REFRESH', payload: tmpUser, clientApi: clientApi, username: username });
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                    }
                    return axios(originalRequest); // Retry the original request with the new access token.
                } catch (refreshError) {
                    // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
                    console.error("Token refresh failed:", refreshError);
                    authDispatch({ type: "LOGOUT" });
                    return Promise.reject(refreshError);
                }
            }
            return Promise.reject(error); // For all other errors, return the error as is.
        }
    );

    const changeEmployeeId = async (oldEmployeeId, newEmployeeId, emplName) => {
        let ret;
        setIsLoading(true);
        await axiosInstance
            .patch(`${clientApi}api/Employee/changeEmplId`, {
                oldEmployeeId: oldEmployeeId,
                newEmployeeId: newEmployeeId,
                emplName: emplName,
            },
                {
                    params: {
                        username: username,
                        currentUserId: account.employeeId,
                    },
                })
            .then((response) => {
                if (response.status === 200) ret = response.data;
                else ret = [];
            })
            .catch((error) => {
                console.log(error.response);
                setIsLoading(false);
                throw error;
            });
        setIsLoading(false);
        return ret;
    };
    return { changeEmployeeId, isLoading };
}